import Image from 'app/Components/Shared/Image/image';
import React, { useState, useCallback, useEffect } from 'react';
import Config from '../../../../Config';
import { prepareSameWindowUrlWithNavigateTo } from 'app/utilities/StringHelpers/StringHelpers';
import { checkLoginData } from 'app/Components/Page/SelfCarePage/Utilities';
import { rolesKeys } from 'app/Components/Block/OTPLoginBlock/Assets/variables';
import { renderAuthButtons } from '../constants';
import EpiContext from '@episerver/spa-core/Spa';
import { isOrgEmployeeLogin } from '../../OTPLoginBlock/Assets/variables';
const SelfCareButton = ({ props }) => {

    const [showSelfCareArea, setShowSelfCareArea] = useState(false);
    const { headerData: { tabs, tabIndex, userData, selfCareData }, isBusinessNavigation } = props;
    // const [userName, setUserName] = useState(headerData?.selfCareData?.buttonTitle?.value || "אזור אישי")
    const { isFullAuthenticated, isOtpAuthenticated, isOtpExtendedAuthenticated, isSilentOtpAuthenticated } = props?.authentication?.loginData;
    console.log(props);

    const loginObject = {
        isFullAuthenticated,
        isOtpAuthenticated,
        isOtpExtendedAuthenticated,
        isSilentOtpAuthenticated
    };
    const isOrgEmployee = isOrgEmployeeLogin(props?.authentication);
    const isUserConnected = checkLoginData(loginObject) || isOrgEmployee;
    const [userName, setUserName] = useState(props?.headerData?.selfCareData?.buttonTitle?.value || "אזור אישי")
    useEffect(() => {
        if (isUserConnected || isOrgEmployee) {
            //console.log("connected")
            if (userData?.firstName && userData?.lastName && (userData?.isFullAuthenticated || isOrgEmployee)) {
                if (userData?.firstName?.length > 7 || userData?.lastName?.length + userData?.firstName?.length < 9) {
                    setUserName(<span className="login-user login-user-overflow">{userData?.firstName + ' ' + userData?.lastName}</span>)
                } else {
                    setUserName(
                        <div className="login-user">
                            <div>{userData?.firstName}</div>
                            <div className="user-lastname">{userData?.lastName}</div>
                        </div>
                    );
                }
            } else if (userData?.isOtpAuthenticated || isOtpExtendedAuthenticated) {
                if (userData?.firstName && userData?.lastName) {
                    setUserName(<span className="login-user login-user-overflow">{userData?.firstName}</span>)
                }
                else {
                    setUserName(<span className="login-user">{userData?.contactNumber}</span>)
                }
            }
        } else {
   
            // User is not connected - use CMS value or fallback
            setUserName(selfCareData?.buttonTitle?.value || "אזור אישי");
        }
    }, [userData, isUserConnected, selfCareData?.buttonTitle?.value])



    const toggleSelfCareButton = useCallback(() => {
        setShowSelfCareArea(prevState => !prevState);
    }, []);

    const handleItemClick = useCallback((item) => {
        prepareSameWindowUrlWithNavigateTo(item?.link?.value, props.context);
    }, [props.context]);

    const handleButtonClick = useCallback(() => {
        if (!isUserConnected) {
            EpiContext.navigateTo(Config.newLoginUrl);
        } else {
            toggleSelfCareButton();
        }
    }, [isUserConnected, toggleSelfCareButton]);

    const buttonClass = tabIndex !== -1 && tabs != undefined && tabs[tabIndex]?.isBusinessTab?.value === false ? 'btn-container-private' : 'btn-container-business'; const loginClass = userData?.isFullAuthenticated === true || userData?.isOtpAuthenticated === true ? 'login' : '';
    const imgClass = showSelfCareArea ? 'up' : 'down';
    const purpleArrowSvg = require('../images/left-svg-purple.svg');
    const selfcarePageState = props.selfcarePage;
    const authButtons = renderAuthButtons(Config, props, prepareSameWindowUrlWithNavigateTo, isUserConnected, setShowSelfCareArea, purpleArrowSvg, selfcarePageState);

    return (
        <div className="btn-container" onMouseEnter={isUserConnected ? toggleSelfCareButton : undefined} onMouseLeave={isUserConnected ? toggleSelfCareButton : undefined}>
            <span
                className={`${loginClass} ${buttonClass}`}
                onClick={handleButtonClick}
            >
                {userName}
                {isUserConnected && (
                    <Image className={imgClass}
                        src={require('../images/down.svg')} />
                )}
            </span>
            {showSelfCareArea && isUserConnected &&
                <div className="self-care-area-box">
                    <div className="self-care-items-purple">
                        {authButtons}
                        {selfCareData !== null && selfCareData?.purpleButtons?.value !== null && (
                            <>
                                {
                                    selfCareData?.purpleButtons?.expandedValue.map((item, i) => (
                                        <div
                                            key={i}
                                            className="item-purple self-care-item"
                                            onClick={() => {
                                                toggleSelfCareButton();
                                                handleItemClick(item)
                                            }
                                            }>
                                            <span>{item?.text?.value}</span>
                                            <Image src={purpleArrowSvg} />
                                        </div>
                                    ))
                                }
                            </>
                        )}
                    </div>
                    {authButtons && (
                        <div className="self-care-area-seperator"></div>
                    )}
                    {selfCareData !== null && selfCareData?.regularButtons?.value !== null && (
                        <div className="self-care-items-regular">
                            {selfCareData?.regularButtons?.expandedValue.map((item, i) => (
                                item.isLinkForContactManager.value ?
                                    props.authentication.loginData.userDetails.IsContactPerson && isUserConnected &&
                                    <div
                                        key={i}
                                        onClick={() => handleItemClick(item)}
                                        className={`${i === selfCareData?.regularButtons?.expandedValue?.length - 1 ? 'last' : ''} item-regular self-care-item`}
                                    >
                                        <span>{item?.text?.value}</span>
                                        <Image src={require('../images/left.svg')} />
                                    </div>
                                    :
                                    item.isLinkForPrivateClient.value ?
                                        !props.authentication.loginData.userDetails.IsContactPerson && isUserConnected &&
                                        <div
                                            key={i}
                                            onClick={() => handleItemClick(item)}
                                            className={`${i === selfCareData?.regularButtons?.expandedValue?.length - 1 ? 'last' : ''} item-regular self-care-item`}
                                        >
                                            <span>{item?.text?.value}</span>
                                            <Image src={require('../images/left.svg')} />
                                        </div>
                                        :
                                        <div
                                            key={i}
                                            onClick={() => handleItemClick(item)}
                                            className={`${i === selfCareData?.regularButtons?.expandedValue?.length - 1 ? 'last' : ''} item-regular self-care-item`}
                                        >
                                            <span>{item?.text?.value}</span>
                                            <Image src={require('../images/left.svg')} />
                                        </div>
                            ))}
                        </div>
                    )}

                    {(isUserConnected) && (
                        <div
                            className="self-care-disconnect "
                            onClick={() => prepareSameWindowUrlWithNavigateTo(Config.logoutPage, props.context)}
                        >
                            <span className="img-location">התנתקות</span>
                            <span>
                                <Image src={require('../images/log_out_desktop.svg')} />
                            </span>
                        </div>
                    )}
                </div>}
        </div>
    );
};

export default SelfCareButton;
